import React from 'react';
import { BackupManager } from '../../components/BackupManager/BackupManager';

export default function BackupsPage() {
  return <BackupManager />;
}
